module.exports = __webpack_public_path__ + "img/code_developers.b5e79ee7.svg";